/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_A11yInputs */

const en_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A11y`)
};

const ar_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إمكانية الوصول`)
};

const bn_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাক্সেসিবিলিটি`)
};

const de_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A11y`)
};

const es_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A11y`)
};

const fr_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A11y`)
};

const pt_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A11y`)
};

const zh_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A11y`)
};

const tr_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A11y`)
};

const ru_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A11y`)
};

const pl_svchip_a11y = /** @type {(inputs: Svchip_A11yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A11y`)
};

/**
* | output |
* | --- |
* | "A11y" |
*
* @param {Svchip_A11yInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_a11y = /** @type {((inputs?: Svchip_A11yInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_A11yInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_a11y(inputs)
	if (locale === "bn") return bn_svchip_a11y(inputs)
	if (locale === "de") return de_svchip_a11y(inputs)
	if (locale === "es") return es_svchip_a11y(inputs)
	if (locale === "fr") return fr_svchip_a11y(inputs)
	if (locale === "pt") return pt_svchip_a11y(inputs)
	if (locale === "zh") return zh_svchip_a11y(inputs)
	if (locale === "tr") return tr_svchip_a11y(inputs)
	if (locale === "ru") return ru_svchip_a11y(inputs)
	if (locale === "pl") return pl_svchip_a11y(inputs)
	return en_svchip_a11y(inputs)
});